import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
export default class UserPermission extends GenexLMSModel {
    static entity = "user-permissions";
    static primaryKey = "name";

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(""),
        };
    }

}
